module.exports = __webpack_public_path__ + "img/code-vue-xl.dfc13601.webp";